module.exports = __webpack_public_path__ + "media/images/emotional-intelligence-e01378086d0aae6854a215f1cfb3f442.jpg";